import { render, staticRenderFns } from "./filter-tags.vue?vue&type=template&id=12ec410e"
import script from "./filter-tags.vue?vue&type=script&lang=js"
export * from "./filter-tags.vue?vue&type=script&lang=js"
import style0 from "./filter-tags.vue?vue&type=style&index=0&id=12ec410e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports